module.exports = __webpack_public_path__ + "static/media/cloud-download-alt.35674d56.svg";